import { supabase } from "@/integrations/supabase/client";

export type RejectionKind = "review" | "comment";

/**
 * Logs a rejected submission for admin review. Safe to call without awaiting —
 * failures are swallowed so they never block user-facing flow.
 */
export async function logRejection(params: {
  kind: RejectionKind;
  content: string;
  reason: string;
  title?: string;
  reviewId?: string;
}) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;
    await supabase.from("rejected_submissions" as any).insert({
      user_id: user.id,
      kind: params.kind,
      content: params.content.slice(0, 15000),
      title: params.title?.slice(0, 500) ?? null,
      review_id: params.reviewId ?? null,
      reason: params.reason.slice(0, 500),
    } as any);
  } catch {
    // best-effort logging only
  }
}
